import translations from './translations'

translations.add('en', {
    iAgreeWith: 'I agree with',
    termsAndConditions: 'terms and conditions',
    pay: 'PAY'
})
